export default "__VITE_ASSET__DB$Bz7y5__"